import { render, staticRenderFns } from "./BlockSwitch.vue?vue&type=template&id=56a71f97&scoped=true&"
import script from "./BlockSwitch.vue?vue&type=script&lang=js&"
export * from "./BlockSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BlockSwitch.vue?vue&type=style&index=0&id=56a71f97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a71f97",
  null
  
)

export default component.exports